module.exports = __webpack_public_path__ + "img/sigap-icone.e4eac091.png";